import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

function PDPStatusIcon({ status }) {
    let icon = <RadioButtonUncheckedIcon color={"disabled"} />;

    switch (status) {
        case "completed":
            icon = <CheckCircleIcon color={"success"} />;

            break;

        case "review":
            icon = <InfoOutlinedIcon color={"info"} />;
            break;

        case "error":
            icon = <ErrorOutlineOutlinedIcon color={"error"} />;
            break;

        default:
            break;
    }

    return icon;
}

export default PDPStatusIcon;
